export default {
  clientID: "Sv08pnUlLUulbwkSHMZdRknclG7YX3dC",
  domain: "agenturid.eu.auth0.com",
  allowedConnections: ["Username-Password-Authentication", "saml1"],
  rememberLastLogin: true,
  language: "en",
  closable: true,
  options: {
    auth: {
      autoParseHash: true,
      responseType: "token id_token",
      redirect: true,
      redirectUrl:
        process.env.NODE_ENV !== "production"
          ? "http://localhost:4000/auth0loginCallback"
          : "https://your_domain_name/auth0loginCallback"
    },
    languageDictionary: {
      title: "Agentur-Cockpit",
      emailInputPlaceholder: "demo@gmail.com",
      passwordInputPlaceholder: "demodemo"
    },
    theme: {
      labeledSubmitButton: true,
      logo: "your_logo_url",
      primaryColor: "#E14615",
      authButtons: {
        connectionName: {
          displayName: "Log In",
          primaryColor: "#b7b7b7",
          foregroundColor: "#000000"
        }
      }
    }
  }
};
